import React, { useEffect, useState } from "react";
import { Form, Button, Spinner, Row, Col } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import axiosNew from "../../store/api/axiosNew";
import { useNavigate } from "react-router-dom";
import Select from "react-select";


const categoryOptions = [
    { value: 1, label: "Apartments" },
    { value: 2, label: "Plots" },
    { value: 3, label: "Villas" },
]

export default function EditProfilePage() {

    const isMobile = useMediaQuery({ maxWidth: 576 })
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [errors, setErrors] = useState({})
    const navigate = useNavigate()
    
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobileNo: "",
        address: "",
        companyName: "",
        jobsPerDay: "",
        teamStrength: "",
        category: "",
        categoryName: "",
        location: "",
        gmbProfileUrl: "",
    })

    useEffect (() => {
        const fetchUser = async () => {
            try {
                setLoading(true)
                const userId = localStorage.getItem("id")
                const res = await axiosNew.get(`/auth/user/${userId}`)
                if (res.data.success) {
                    const u = res.data.data
                    setFormData({
                        name: u.name || "",
                        email: u.email || "",
                        mobileNo: u.mobileNo || "",
                        address: u.address || "",
                        companyName: u.companyName || "",
                        jobsPerDay: u.jobsPerDay || "",
                        teamStrength : u.teamStrength || "",
                        category: u.category || "",
                        categoryName : u.categoryName || "",
                        location : u.location || "",
                        gmbProfileUrl : u.gmbProfileUrl || "",
                    })
                }
            }
            catch (err) {
                console.error("Error fetching user details:", err)
            }
            finally {
                setLoading(false)
            }
        }
        fetchUser()
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value.trim() })
        if (errors[name]) {
            setErrors({ ...errors, [name]: "" })
        }
    }

    const validateForm = () => {
        const newErrors = {}
        const requiredFields = [
    "name",
    "address",
    "companyName",
    "jobsPerDay",
    "teamStrength",
    "location",
    "gmbProfileUrl",
  ];

  requiredFields.forEach((field) => {
    if (!formData[field] || !String(formData[field]).trim()){
        newErrors[field] = `${field} is required`
    }
  })

  if (!formData.category) {
  newErrors.category = "Category is required";
}
if (!formData.categoryName) {
  newErrors.categoryName = "Category name is required";
}


  if (!formData.jobsPerDay) {
  newErrors.jobsPerDay = "Jobs per day is required";
} else if (isNaN(formData.jobsPerDay)) {
  newErrors.jobsPerDay = "Jobs per day must be a number";
}

if (!formData.teamStrength) {
  newErrors.teamStrength = "Team strength is required";
} else if (isNaN(formData.teamStrength)) {
  newErrors.teamStrength = "Team strength must be a number";
}


  setErrors(newErrors)
  return Object.keys(newErrors).length === 0
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!validateForm()) return
        
        setSaving(true)
        try {
            const userId = localStorage.getItem("id")
            await axiosNew.put(`/auth/user/${userId}`, formData)
            console.log("Profile updated successfully!")
            navigate("/upgrade-plan")
        }
        catch (err) {
            console.error("Error updating profile:", err)
        }
        finally {
            setSaving(false)
        }
    }

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                <Spinner animation="border" variant="primary" />
            </div>
        )
    }

    return (
        <div style={{ margin: "0 auto", padding: isMobile ? "12px" : "20px" }}>
            <h3 style={{ marginBottom: isMobile ? "20px" : "25px", color: "#007bbd", textAlign: "left" }}>Upgrade Subscription - Edit Profile Details</h3>

            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: isMobile ? "14px" : "16px" }}>Email</Form.Label>
                    <Form.Control type="email" name="email" value={formData.email} readOnly style={{ background: "#f5f5f5", fontSize: isMobile ? "14px" : "16px" }} />
                </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: isMobile ? "14px" : "16px" }}>Mobile No</Form.Label>
                    <Form.Control type="text" name="mobileNo" value={formData.mobileNo} readOnly style={{ background: "#f5f5f5", fontSize: isMobile ? "14px" : "16px" }} />
                </Form.Group>
                </Col>
                </Row>
                <Row>
                    
                {[
                    { name: "name", label: "Name" },
                    { name: "address", label: "Address" },
                    { name: "companyName", label: "Company Name" },
                    { name: "jobsPerDay", label: "Jobs Per Day" },
                    { name: "teamStrength", label: "Team Strength" },
                    { name: "location", label: "Location" },
                    { name: "gmbProfileUrl", label: "GMB Profile URL" },
                ].map((field) => (
                    <Col xs={12} md={4} key={field.name}>
                    <Form.Group className="mb-3" >
                        <Form.Label style={{ fontSize: isMobile ? "14px" : "16px" }}>{field.label}</Form.Label>
                        <Form.Control style={{ fontSize: isMobile ? "14px" : "16px"}} type={field.name === "jobsPerDay" || field.name === "teamStrength" ? "number" : "text"} name={field.name} value={formData[field.name]} onChange={handleChange} />
                        {errors[field.name] && (
                            <small style={{ color: "red" }}>{errors[field.name]}</small>
                        )}
                    </Form.Group>
                    </Col>
                ))}
                <Col xs={12} md={4} >
                <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: isMobile ? "14px" : "16px" }}>Category</Form.Label>
                    <Select options={categoryOptions} value={categoryOptions.find(opt => String(opt.value) === String(formData.category))} onChange={(selected) => {
                        setFormData({ ...formData, category: selected.value, categoryName: selected.label, });
                        if (errors.category || errors.categoryName) {
        setErrors(prev => ({ ...prev, category: "", categoryName: "" }));
      }
                    }} placeholder="Select Category" />
                    {(errors.category || errors.categoryName) && ( <small style={{ color: "red" }}>{errors.category || errors.categoryName} </small>)}
                </Form.Group>
                </Col>
                </Row>
                <div className="d-flex justify-content-center">
                <Button type="submit" disabled={saving} style={{ width: "30%", background: "linear-gradient(to right, #535db9, #0f3386)", borderColor: "transparent", fontSize: isMobile ? "14px" : "16px", fontWeight: "600", marginTop: isMobile ? "12px" : "16px" }}>
                    {saving ? "saving..." : "Update Profile"}
                </Button>
                </div>
            </Form>
        </div>
    )
}